export default {
  border: '#333',
  tooltipBackground: '#FFF',
  selectedObject: {
    borderColor: '#5598c1',
    cornerColor: '#5598c1',
  },
  cropFill: 'rgba(85, 152, 195, 0.25)',
};
